// UI 관련 상수

export const COLORS = {
  PRIMARY: '#1890ff',
  SUCCESS: '#52c41a',
  WARNING: '#faad14',
  ERROR: '#ff4d4f',
  INFO: '#1890ff',

  STATUS: {
    ACTIVE: '#52c41a',
    INACTIVE: '#d9d9d9',
    PENDING: '#faad14',
    FAILED: '#ff4d4f',
    SUCCESS: '#52c41a',
    RUNNING: '#1890ff',
    PAUSED: '#faad14',
    DELETED: '#ff4d4f',
  },

  DATA_TYPE: {
    STRING: '#722ed1',
    INTEGER: '#13c2c2',
    FLOAT: '#52c41a',
    BOOLEAN: '#fa8c16',
    DATETIME: '#eb2f96',
    ARRAY: '#1890ff',
    OBJECT: '#faad14',
  },

  SOURCE: {
    MLFLOW: '#ff7875',
    AIRFLOW: '#40a9ff',
    OPENMETADATA: '#73d13d',
    MANUAL: '#d3adf7',
  },
} as const;

export const SIZES = {
  PAGE_SIZE: {
    SMALL: 10,
    MEDIUM: 20,
    LARGE: 50,
    EXTRA_LARGE: 100,
  },

  TABLE_ROW_HEIGHT: {
    COMPACT: 32,
    MEDIUM: 48,
    LARGE: 64,
  },

  AVATAR_SIZE: {
    SMALL: 24,
    MEDIUM: 32,
    LARGE: 40,
    EXTRA_LARGE: 64,
  },

  ICON_SIZE: {
    SMALL: 14,
    MEDIUM: 16,
    LARGE: 20,
    EXTRA_LARGE: 24,
  },
} as const;

export const BREAKPOINTS = {
  XS: 480,
  SM: 576,
  MD: 768,
  LG: 992,
  XL: 1200,
  XXL: 1600,
} as const;

export const LAYOUT = {
  HEADER_HEIGHT: 64,
  SIDEBAR_WIDTH: 240,
  SIDEBAR_COLLAPSED_WIDTH: 80,
  FOOTER_HEIGHT: 48,

  PADDING: {
    SMALL: 8,
    MEDIUM: 16,
    LARGE: 24,
    EXTRA_LARGE: 32,
  },

  SPACING: {
    SMALL: 8,
    MEDIUM: 16,
    LARGE: 24,
    EXTRA_LARGE: 32,
  },
} as const;

export const ANIMATION = {
  DURATION: {
    FAST: 200,
    MEDIUM: 300,
    SLOW: 500,
  },

  EASING: {
    EASE_IN: 'ease-in',
    EASE_OUT: 'ease-out',
    EASE_IN_OUT: 'ease-in-out',
  },
} as const;

export const Z_INDEX = {
  DROPDOWN: 1000,
  MODAL: 1050,
  POPOVER: 1060,
  TOOLTIP: 1070,
  NOTIFICATION: 1080,
} as const;

export const TEXT = {
  MAX_TAG_LENGTH: 20,
  MAX_BREADCRUMB_LENGTH: 20,
} as const;

export const AVATAR_COLORS = [
  'var(--opds-glo-palette-blue-80)',
  'var(--opds-glo-palette-purple-80)',
  'var(--opds-glo-palette-green-80)',
  'var(--opds-glo-palette-yellow-80)',
  'var(--opds-glo-palette-red-80)',
  'var(--opds-glo-palette-orange-80)',
  'var(--opds-glo-palette-olive-80)',
  'var(--opds-glo-palette-chartreuse-80)',
  'var(--opds-glo-palette-emerald-80)',
  'var(--opds-glo-palette-turquoise-80)',
  'var(--opds-glo-palette-indigo-80)',
  'var(--opds-glo-palette-fuchsia-80)',
  'var(--opds-glo-palette-magenta-80)',
] as const;

export const NOTIFICATION_PLACEMENT = 'bottomLeft' as const;

export const PAGINATION_OPTIONS = [10, 20, 50, 100] as const;
export const DEFAULT_PAGE_SIZE = 10;

export const SEARCH_RESULTS = {
  ITEM_HEIGHT: 120,
  SCROLL_THRESHOLD: 100,
  DEFAULT_VIEWPORT_OFFSET: 204,
  DOMAIN_VIEWPORT_OFFSET: 412,
  CONTAINER_OFFSET: 16,
} as const;

/**
 * 최근 변경된 자산 목록 관련 상수
 */
export const MY_ASSETS = {
  PAGE_SIZE: 15,
  SCROLL_THRESHOLD: 100,
} as const;

/**
 * OwnerAvatars 컴포넌트 크기 상수
 * - TABLE: Antd Table 컬럼에서 사용 (이름 없이 아바타만 표시)
 * - DETAIL: 상세 정보, 사이드바, 카드 등에서 사용 (이름과 함께 표시)
 */
export const OWNER_AVATAR_SIZES = {
  TABLE: 28,
  DETAIL: 20,
} as const;

export const DEFAULT_CLASSIFICATION = '기타' as const;

/**
 * 드롭다운 컴포넌트 width 상수
 */
export const DROPDOWN_WIDTHS = {
  ASSET_TYPE: 278,
  DOMAIN: 278,
  TAG: 278,
  CERTIFICATION: 278,
  TIER: 278,
} as const;

/**
 * 모달 가로 폭 (디자인 규격)
 * - CONFIRM_ALERT: 확인/알림
 * - COMPACT_FORM: 프로젝트·런·실험 생성, 설명 편집, 라이브러리 파일 업로드
 * - STANDARD_FORM: 그 외 필드 입력 폼
 */
export const MODAL_WIDTHS = {
  CONFIRM_ALERT: 400,
  COMPACT_FORM: 520,
  STANDARD_FORM: 640,
  LARGE_PANEL: 800,
} as const;

/** 모든 모달 footer 버튼 공통 크기 (120×40) */
export const MODAL_FOOTER_BUTTON_SIZE = {
  w: 120,
  h: 40,
} as const;
